import React, { useEffect, useState } from "react";
import CardLayout from "src/layout/CardLayout";
import GridLayout from "src/layout/GridLayout";

const MegaMenu = ({ menuItems, closeMenu }) => {
  const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
    // Trigger animation after render
    const timeout = setTimeout(() => setIsVisible(true), 10);
    return () => clearTimeout(timeout);
  }, []);


  return (
    <div
     className={`absolute w-full z-50 transition-all duration-300 ease-outAdd commentMore actions
        origin-top transform
        ${isVisible ? 'scale-y-100 opacity-100' : 'scale-y-0 opacity-0'}
      `}
      style={{ top: "80%" }}
    >
      <div className="bg-white shadow-lg mt-8 h-fit px-4">
        {menuItems.map((item, index) => (
          <div key={index}>
             {item.subMenu && item?.subMenuCardData?.length > 0 && (
              <CardLayout data={item.subMenuCardData} closeMenu={closeMenu} />
            )}
            {item?.subMenu && item?.subMenuGridData && (
              <GridLayout data={item?.subMenuGridData} closeMenu = {closeMenu} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MegaMenu;